/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CardUpdate: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M21 0H3C1.346 0 0 1.346 0 3V16C0 17.654 1.346 19 3 19H10V17H3C2.448 17 2 16.551 2 16V11H24V3C24 1.346 22.654 0 21 0ZM2 5V3C2 2.449 2.448 2 3 2H21C21.552 2 22 2.449 22 3V5H2Z'
      fill='currentColor'
    />
    <path
      d='M18.0002 13C15.7182 13 13.7272 14.542 13.1572 16.75L15.0952 17.249C15.4362 15.925 16.6302 15 18.0002 15C18.8082 15 19.5732 15.331 20.1312 15.893L18.5232 17.061L22.7922 18L23.2202 13.649L21.7542 14.714C20.8142 13.644 19.4512 13 18.0002 13Z'
      fill='currentColor'
    />
    <path
      d='M18.0003 22C17.1923 22 16.4273 21.669 15.8693 21.107L17.4773 19.939L13.2083 19L12.7803 23.351L14.2463 22.286C15.1863 23.356 16.5493 24 18.0003 24C20.2823 24 22.2733 22.458 22.8433 20.25L20.9053 19.751C20.5643 21.075 19.3703 22 18.0003 22Z'
      fill='currentColor'
    />
  </React.Fragment>
)
